import { AppContextType } from "../../../../context/AppContext";
import useAppContext from "../../../../hooks/useAppContext";
import { initialIndividualState } from "../../../../static/initialState/commonInitialState/individualInitialState";
import { LegalEntityWithRepresentativeInitialState } from "../../../../static/initialState/commonInitialState/legalEntityInitalState";
import { IndividualPersonType } from "../../../../static/types/commonTypes/individualType";
import { LegalEntityWithRepresentativeType } from "../../../../static/types/commonTypes/legalEntityType";
import { ManagerWithRepresentativeType } from "../../../../static/types/limited-company-creation/managerWithRepresentativeType";
import { entityTypes } from "../../../../static/types/objectType";
import IndividualPerson from "../../../commonComponents/IndividualPerson";
import LegalEntityWithRepresentative from "./LegalEntityWithRepresentative";

type managerProps = {
    checked: boolean,
    manager: ManagerWithRepresentativeType,
    societyType?: string | string [],
    draftFieldName?: string,
    setChecked: ( checked: boolean ) => void,
    setManager?: ( manager: ManagerWithRepresentativeType | any ) => void,
    updateManagerValidity: ( isValid: boolean ) => void
}

export default function ManagerWithRepresentative ({
    checked,
    manager,
    setManager,
    setChecked,
    societyType,
    draftFieldName,
    updateManagerValidity
}: managerProps ) {

    
    const {
        draftFormData, setDraftFormData
    } = useAppContext() as AppContextType
    
    const stringifyDraft = ( data: any ) => { return JSON.stringify( data )}
    const parseDraft: any = () => { return draftFormData ? JSON.parse( draftFormData ) : {} }
    
    const updateEntityDetails = (details: Partial<IndividualPersonType | LegalEntityWithRepresentativeType>) => {
        if ( setManager ){

            setManager(  ( prev: any ) => {
                if (prev.person === "Personne physique") {
                    return { ...prev, personDetails: { ...prev.personDetails, ...details } };
                } else {
                    return { ...prev, entityDetails: { ...prev.entityDetails, ...details } };
                }
            });
            
            let draft = parseDraft()
            const tempDraft = { ...draft, [ draftFieldName || 'statutoryAuditorWithRepresentative' ]: manager }
            setDraftFormData( stringifyDraft( tempDraft ))
        }
    };
    
    const handlePersonChange = (person: "Personne physique" | "Personne morale") => {
        if ( setManager ){
            setManager( person === "Personne physique"
            ? { person, personDetails: initialIndividualState }
            : { person, entityDetails: LegalEntityWithRepresentativeInitialState });
        }
        setChecked( false )
    };

    return(
        <div className = "tab-content">

            <div className = "mb-3 row">
                <div className = "mb-3 row">
                    <label htmlFor="personne" className = "col-sm-2 col-form-label">Personne</label>
                    <div className = "col-sm-10">
                        <select
                            className = "form-select"
                            id = "person"
                            onChange = { e => handlePersonChange(e.target.value as "Personne physique" | "Personne morale") }
                            value = { manager?.person || "" }
                        >
                            {
                                entityTypes.map( option=> 
                                    <option key = { option } value = { option }>
                                        { option }
                                    </option>
                                )
                            }
                        </select>
                    </div>
                </div>
            </div>

            {
                manager.person === 'Personne physique' &&
                <IndividualPerson
                    checked = { checked }
                    individual = { manager.personDetails }
                    changeIndividual = { updateEntityDetails }
                    onValidationChange = { updateManagerValidity }
                />
            }

            {
                manager.person === 'Personne morale' &&
                <LegalEntityWithRepresentative
                    checked = { checked }
                    legalEntity = { manager.entityDetails }
                    changeLegalEntity = { updateEntityDetails }
                    societyType = { societyType }
                    onValidationChange = { updateManagerValidity }
                    representativeLabel = "Représentant de la société"
                />
            }

        </div>
    )
}